<template>
  <div class="communication-tab" :id="id">
    <div class="communications" v-loading="visibleLoader">
      <div
        ref="messages"
        v-if="communications.length"
        :class="['messages', visibleScrollbar ? 'messages--scrollable' : '']"
        @scroll="handleScroll"
      >
        <Message
          v-for="msg in communications"
          ref="message"
          :key="msg.id"
          :msg="msg"
          :id="id"
          :name="name"
          :emails="emails"
        ></Message>
      </div>
      <div v-else class="empty">
        Список сообщений пуст. <br />
        Вы можете отправить кандидату первое сообщение
      </div>
    </div>
    <form
      :id="`msg-form-${id}`"
      enctype="multipart/form-data"
      class="communications-control"
    >
      <div v-if="uploaded_files.length" class="upload-list shadow-lvl-3 brs-4">
        <DocumentRow
          v-for="(file, i) in uploaded_files"
          :key="file.uid"
          :document="file"
          :index="i"
          :details-text="Number(file.size / 1024 / 1024).toFixed(2) + ' Мб'"
          :document-name="file.name"
          :allow-remove="true"
          :visible-delete-icon="true"
          @delete-file="deleteFile"
        />
      </div>
      <div v-else class="communications-control__btns">
        <div class="communication-inputbox">
          <div class="message-area">
            <button
              v-if="!allowCreateMessage"
              v-loading="btnVisibleLoader"
              type="button"
              @click="initMessengerMode"
              @mouseenter="dialogBtnHovered = true"
              @mouseleave="dialogBtnHovered = false"
              :class="[
                params.hasTelegram ? 'start-dialog-btn' : 'check-dialog-btn',
                'fw-500'
              ]"
            >
              <template v-if="params.hasTelegram">
                <blocked-icon :unblocked="dialogBtnHovered"></blocked-icon>
                Нажмите, чтобы начать диалог
              </template>
              <template v-else>
                <Icon iconName="info" />
                Нажмите, чтобы проверить канал
              </template>
            </button>
            <div v-else class="flex-column" v-loading="templateLoader">
              <div class="message-area__input">
                <Dropdown
                  :field="{
                    type: 'enum',
                    placeholder: 'Выберите шаблон',
                    name: 'telegramTemplate'
                  }"
                  :clearable="true"
                  :model="template"
                  :options="templatesOptions"
                  :reserve-keyword="true"
                  :size="'big' || 'medium'"
                  @set-value="(name, val) => handleCommand(val)"
                  @filter-option="
                    (str, method) => getTelegramTemplates(str, method)
                  "
                />
                <Tooltip content="Создать новый шаблон"
                  ><Button
                    v-show="accessToCreateTemplate"
                    :disabled="!accessToCreateTemplate"
                    buttonColor="blue"
                    buttonText=""
                    buttonSize="big"
                    hasLeftIcon
                    iconName="Plus"
                    @click="handleCommand('createTemplate')"
                  />
                </Tooltip>
              </div>
              <div class="message-area__input">
                <TextArea
                  ref="newMsg"
                  resize="none"
                  :hasResizeIcon="false"
                  :model="newMessage"
                  :field="{ placeholder: 'Сообщение' }"
                  maxlength="10000"
                  @change="changeText"
                  @keydown.native.enter.exact="sendMsg($event)"
                  class="message-area__textarea"
                />

                <Button
                  :disabled="!newMessage.trim()"
                  buttonColor="blue"
                  buttonText=""
                  buttonSize="big"
                  hasLeftIcon
                  iconName="Send"
                  @click="sendMsg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { store } from '@/store';
import { mixin, errorMsg } from '@/utils/mixins';
import { getController, postController } from '@/controllers/request.js';
import {
  ACTION,
  SUBPANEL,
  FIELD,
  MODULE,
  BUTTON,
  SORT_PARAMS,
  SORT_ORDER,
  EVENTBUS_EVENTS
} from '@/utils/constants';
import Message from 'Elements/Messenger/Message';
import TextArea from 'Elements/Textarea/Textarea';
import Button from 'Elements/Button/Button';
import BlockedIcon from 'Elements/SVG/BlockedIcon';
import Icon from 'Elements/Icon/Icon';
import DocumentRow from 'Elements/Document/DocumentRow';
import Dropdown from 'Elements/Select/Dropdown';
import Tooltip from 'Elements/Tooltip/Tooltip';
import { eventBus } from '@/bus';

export default {
  mixins: [mixin, errorMsg],
  props: {
    module: String,
    id: String,
    tab: Object,
    tableSql: String,
    userId: String,
    name: String,
    emails: {
      type: Array,
      default: () => []
    },
    allowedScroll: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default() {
        return {
          hasTelegram: Boolean,
          messagesCount: Number,
          lastEmailId: {
            type: [Number, String],
            default: 0
          },
          telegram: {
            type: String,
            default: ''
          }
        };
      }
    }
  },
  data() {
    return {
      // MODULE,
      telegramModule: MODULE.HRPAC_TELEGRAM_MESSAGES,
      SORT_PARAMS,
      no_profile_photo: '/front/public/style/img/avatar.jpg',
      formParams: {
        [SORT_PARAMS.SORT_ORDER]: SORT_ORDER.DESC,
        [SORT_PARAMS.CANDIDATES_EMAILS_CELL_ORDER_BY]: FIELD.ID.DATE_ENTERED,
        [SORT_PARAMS.CANDIDATES_EMAILS_CELL_OFFSET]: 0
      },
      // pageData: null,
      endPage: false,
      communications: [],
      allowCreateMessage: false,
      dialogBtnHovered: false,
      newMessage: '',
      lastTelegramMsgID: 0,
      lastEmailMsgID: this.params.lastEmailId,
      // lastScrolledMsg: '',
      visibleLoader: false,
      btnVisibleLoader: false,
      visibleScrollbar: false,
      visibleAuthForm: false,
      sessionId: '',
      accessToCreateTemplate: false,
      templatesOptions: [],
      template: '',
      urlCreateTemplate: '',
      templateLoader: false,

      uploaded_files: []
    };
  },
  created() {
    this.getCommunications();
    this.getTelegramTemplates();
  },
  computed: {
    noEmailSettings() {
      return store.state.common.notifications.send_mail;
    },
    notAccess() {
      return (
        store.state.candidate.metaData &&
        store.state.candidate.metaData.buttons_menu.some(row =>
          row.some(
            btn => btn.id == BUTTON.ID.SEND_MAIL && btn.visibility == 'disabled'
          )
        )
      );
    },
    requestSent: {
      get() {
        return store.state.common.requestSent;
      },
      set(val) {
        store.commit('common/setRequestState', val);
      }
    }
  },
  methods: {
    async handleCommand(arg) {
      if (arg && arg != 'createTemplate') {
        this.templateLoader = true;
        const formData = new FormData();

        formData.set('parent_type', 'HRPAC_CANDIDATES');
        formData.set('parent_id', this.id || '');

        try {
          const resp = await postController({
            url: `/index.php?entryPoint=emailTemplateData&emailTemplateId=${arg}&to_pdf=true`,
            options: formData
          });

          const { data, error } = resp.data;

          if (error) {
            this.showErrorMessage(error);
            return;
          }

          if (data.multiple_values) {
            this.showNotification({
              offset: 100,
              showClose: true,
              message: `Для некоторых переменных найдено несколько значений. Оставьте нужные варианты`,
              duration: 10000,
              type: 'warning'
            });
          }

          if (!data || !data.field_mapping) return;

          for (let key in data.field_mapping) {
            if (key == 'body_from_html' && data[key]) {
              this.newMessage = '';
              this.newMessage = this.formatMessage(data[key]);
            }
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка выбора шаблона письма',
            'select email template'
          );
        } finally {
          this.templateLoader = false;
          this.template = arg;
        }
      } else if (arg == 'createTemplate' && this.urlCreateTemplate) {
        window.open(this.urlCreateTemplate, '_blank');
      } else {
        this.template = '';
      }
    },
    async getTelegramTemplates(searchString) {
      this.templatesOptions = [];
      let url = '?module=HRPAC_TELEGRAM_MESSAGES&action=get_telegram_templates';
      if (searchString) {
        url += `&search_string=${searchString.trim()}`;
      }
      try {
        const resp = await getController({ url });

        if (resp?.data?.data) {
          this.accessToCreateTemplate =
            resp.data.data.accessToCreateTemplate || false;

          this.urlCreateTemplate = resp.data.data.urlCreateTemplate || '';

          this.templatesOptions = resp.data.data.templates
            ? resp.data.data.templates
            : [{ id: '0', name: 'Нет шаблонов' }];
        }
      } catch (err) {
        console.error(err, 'Возникла ошибка при получении шаблонов');
      }
    },
    changeText(a, b) {
      this.newMessage = b;
    },
    updateTab(count) {
      if (!this.params.messagesCount) {
        this.$emit('set-tab-name', this.tab, { count });
      }
    },
    getCommunications() {
      this.visibleLoader = true;
      getController({
        params: {
          module: this.module,
          subpanel: this.tableSql || SUBPANEL.EMAILS,
          action: ACTION.SUBPANEL_JSON_DATA,
          record: this.id,
          inline: 1,
          to_pdf: true,
          ...this.formParams
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (resp.data && !errors) {
            const { PAGINATION, ROWS } = resp.data;

            if (PAGINATION.offsets.next !== -1) {
              this.$set(
                this.formParams,
                SORT_PARAMS.CANDIDATES_EMAILS_CELL_OFFSET,
                PAGINATION.offsets.next
              );
            } else {
              this.endPage = true;
            }

            const newMsgs = ROWS.slice().reverse();
            this.communications = [...newMsgs, ...this.communications];

            if (ROWS.length) {
              const startIteration = PAGINATION.offsets.current == 0;
              this.scrollMsgToBottom(!startIteration ? ROWS[0].id : null);
              this.updateTab(ROWS.length);
            }
          }

          if (errors) {
            this.showErrorMessage(errors);
          }
        })
        .catch(err => {
          this.catchError(
            err,
            err || 'Возникла ошибка загрузки списка коммуникаций',
            'communications loading'
          );
        })
        .finally(() => {
          this.visibleLoader = false;
          this.updateEmails();
        });
    },
    checkTelegramAccount() {
      getController({
        params: {
          module: 'Communications',
          action: 'check_communication',
          candidate_id: this.id,
          type: 'telegram'
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (resp.data && resp.data.communication) {
            this.allowCreateMessage = true;
          }
          if (errors) {
            this.showErrorMessage(errors);
          }

          if (!resp.data.communication && resp.data.result) {
            this.showNotification({
              showClose: true,
              message:
                'Кандидат еще не зарегистрирован в Телеграм. Попробуйте другой канал связи.',
              type: 'warning'
            });
          }
        })
        .catch(err =>
          this.catchError(
            err,
            err || 'Возникла ошибка при проверке наличия аккаунта телеграм',
            'telegram check'
          )
        )
        .finally(() => (this.btnVisibleLoader = false));
    },
    initMessengerMode() {
      this.btnVisibleLoader = true;
      if (!this.params.hasTelegram) {
        this.checkTelegramAccount();
        return;
      }

      // получение переписки и инициализация общения
      const action = 'init_telegram_session';
      getController({
        params: {
          module: this.telegramModule,
          action,
          user_id: this.userId,
          candidate_id: this.id,
          to_pdf: true
        }
      })
        .then(resp => {
          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (!errors) {
            this.processMessageData(resp, action);

            if (resp.data.result) {
              this.allowCreateMessage = true;
            }
          } else {
            this.showErrorMessage(errors);
          }
        })
        .catch(err =>
          this.catchError(
            err,
            err || 'Возникла ошибка при получении списка коммуникаций',
            'communications load'
          )
        )
        .finally(() => (this.btnVisibleLoader = false));
    },
    processMessageData(resp, action) {
      if (!resp.data || !resp.data.result) return;

      if (action == 'check_new_emails') {
        this.communications = [...this.communications, ...resp.data.result];
        this.lastEmailMsgID = resp.data.result[0].id;

        if (!this.params.messagesCount) this.updateTab(resp.data.result.length);
        this.scrollMsgToBottom();
      } else {
        const msgsCount = resp.data.messages.length;
        this.communications = [...this.communications, ...resp.data.messages];

        if (action == 'init_telegram_session') {
          this.lastTelegramMsgID = resp.data.offset_id;
        }

        if (msgsCount) {
          this.scrollMsgToBottom();
          this.updateTab(msgsCount);
          this.lastTelegramMsgID =
            resp.data.messages[0].message_id || resp.data.messages[0].id;
        }
      }
    },
    scrollMsgToBottom(lastScrolledMsgId) {
      // для телеграм-режима только скролл вниз
      this.$nextTick(() => {
        const msgs = this.$refs.messages;
        const cardPage = document.getElementsByClassName(
          'candidate-card__page'
        )[0];
        const scrollValue = lastScrolledMsgId
          ? this.$refs.message.find(`[data-id="${lastScrolledMsgId}"]`)[0]
              .offsetTop
          : msgs?.scrollHeight;

        cardPage?.scrollTo({
          top: cardPage?.scrollHeight,
          behavior: 'smooth'
        });
        msgs?.scrollTo({
          top: scrollValue
        });
      });
    },
    formatMessage(newMessage) {
      let message = this.formatHtml(newMessage);

      message = message.replaceAll('<p>&nbsp;</p>', '\n');
      message = message.replaceAll('</p><p>', '\n');
      message = message.replaceAll('&nbsp;', '\n');
      message = message.replace(/<\/[^>]+>/g, '\n');
      message = message.replaceAll('<br>', '\n');
      message = message.replace(/<\/?[^>]+(>|$)/g, '');
      return message;
    },

    sendMsg() {
      // отправка нового сообщ-я доступна, если введен текст или добавлен файл
      // Максимальный размер файла - 30 мб
      if (this.newMessage && this.newMessage.trim()) {
        this.templateLoader = true;

        let message = this.formatMessage(this.newMessage);

        const defaultParams = {
          module: this.telegramModule,
          action: 'send_telegram_message',
          user_id: this.userId,
          parent_id: this.id,
          message: message.trim()
        };

        // const form = document.getElementById('msg-form-' + this.id);
        let formData = new FormData();

        for (let key in defaultParams) {
          formData.set(key, defaultParams[key]);
        }
        // formData.set('msg', this.newMessage);

        if (this.uploaded_files.length) {
          this.uploaded_files.forEach(file => {
            const { raw: blob, name } = file;
            formData.set('file', blob, name);
          });
        }

        postController({ options: formData })
          .then(resp => {
            const errors = resp.data
              ? resp.data.error || resp.data.errors
              : null;

            this.newMessage = '';

            if (errors?.length) {
              this.showErrorMessage(errors);
            } else {
              this.template = '';
            }
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при отправке нового сообщения',
              'send telegram message'
            )
          )
          .finally(() => (this.templateLoader = false));
      }
    },
    checkTelegramMessages() {
      const subscriber = setInterval(async () => {
        if (!this.allowCreateMessage) {
          clearInterval(subscriber);
        }

        try {
          const action = 'check_new_telegram_messages';
          const resp = await getController({
            params: {
              module: this.telegramModule,
              action,
              user_id: this.userId,
              candidate_id: this.id,
              offset_id: this.lastTelegramMsgID
            }
          });

          const errors = resp.data ? resp.data.error || resp.data.errors : null;
          if (errors) {
            this.showErrorMessage(errors);
            this.allowCreateMessage = false;
            clearInterval(subscriber);
          } else {
            this.processMessageData(resp, action);
          }
        } catch (err) {
          this.catchError(
            err,
            'Возникла ошибка при получении новых сообщений Telegram',
            'check new telegram messages'
          );
        }
      }, 5000);
    },
    handleScroll(e) {
      if (e.target.scrollTop == 0 && !this.endPage) {
        this.visibleLoader = true;
        this.getCommunications();
      }
    },
    showAuthForm() {
      if (!this.requestSent) {
        this.requestSent = true;

        getController({
          url: `index.php?module=Users&action=getFieldsForModule&fields[]=user_name&id=${this.userId}&to_pdf=true`
        })
          .then(resp => {
            if (resp.data && resp.data.length) {
              this.sessionId = `${resp.data[0].value}_${Date.now()}`;
              this.visibleAuthForm = true;
              eventBus.$emit(EVENTBUS_EVENTS.ASK_TO_OPEN_TELEGRAM_DIALOG, {
                telegramModule: this.telegramModule,
                sessionId: this.sessionId,
                userId: this.userId
              });
            }
          })
          .catch(err =>
            this.catchError(
              err,
              'Возникла ошибка при получении логина пользователя для сессии телеграм',
              'get user login'
            )
          )
          .finally(() => (this.requestSent = false));
      }
    },
    uploadFile(file) {
      console.log(file, 'upload');
      // this.uploaded_files.push(file); //эта строка не понадобится
    },
    deleteFile(file, index) {
      console.log('remove', file);
      this.uploaded_files.splice(index, 1);
    },
    updateEmails() {
      // проверка новых емейлов
      getController({
        params: {
          module: 'Communications',
          action: 'check_new_emails',
          user_id: this.userId,
          candidate_id: this.id,
          offset_id: this.lastEmailMsgID,
          to_pdf: true
        }
      })
        .then(resp => {
          if (resp.data.result) {
            if (resp.data.result.length == 1 && resp.data.result[0].id == null)
              return;
            this.processMessageData(resp, 'check_new_emails');
          } else {
            throw new Error(resp.data.error || resp.data.errors);
          }
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка при получении новых email-сообщений',
            'new email messages load'
          )
        );
    }
  },
  watch: {
    allowCreateMessage: function () {
      if (this.allowCreateMessage) {
        this.checkTelegramMessages();
      }
    },
    'communications.length': function () {
      // корректировка отступов враппера при наличии скроллбара
      this.$nextTick(() => {
        const msgs = this.$refs.messages;
        this.visibleScrollbar = msgs
          ? msgs.offsetHeight < msgs?.scrollHeight
          : false;
      });
    }
  },
  beforeDestroy() {
    // останавливаем цикл проверки новых сообщений телеграм
    this.allowCreateMessage = false;
  },
  components: {
    Message,
    BlockedIcon,
    Icon,
    TextArea,
    Button,
    DocumentRow,
    Dropdown,
    Tooltip
  }
};
</script>
<style lang="scss">
.communication-tab {
  .el-dialog .el-dialog__body {
    scrollbar-width: none !important;
  }
}

.el-message.el-message--telegram {
  z-index: 3020 !important;
}

.el-tabs__item {
  &.no-msg:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-color: inherit;
    border: 1.3px solid $green-600;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 8px;
  }

  &.has-msg:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    background-color: $green-600;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-left: 8px;
  }
}
</style>

<style lang="scss" scoped>
.communications {
  background: $white;
  padding: 24px;
  border-bottom: 1px solid #e9edf2;

  &-control {
    background-color: $black-10;

    &__btns {
      position: relative;
      background-color: $white;
      // box-shadow: 0px -3px 9px rgba(0, 0, 0, 0.04);
      z-index: 2;
    }
  }
}

.messages {
  // padding-top: 20px;
  height: 680px;
  overflow-x: hidden;
  overflow-y: auto;
  // margin-right: -20px;
  // scrollbar-width: none;

  &::-webkit-scrollbar {
    width: 12px;
    background-color: $blue-20;
    border-radius: 4px;
  }
}

.communication-inputbox {
  padding-top: 8px;
  display: inline-flex;
  width: 100%;
}

.email-button {
  align-self: flex-end;
  -ms-grid-row-align: flex-end;
}

.message-area {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding: 8px 24px 24px;
  align-items: flex-start;

  .flex-column {
    gap: 8px;
  }

  .select-messengers {
    justify-content: center;
    align-self: flex-end;
    -ms-grid-row-align: flex-end;
  }

  &__input {
    width: 100%;
    gap: 8px;
    display: flex;

    .message-area__textarea {
      min-height: 40px !important;
      align-self: center;
      -ms-grid-row-align: center;
      width: 100%;

      & ::v-deep .el-textarea__inner {
        min-height: 40px;
        padding: 8px 12px !important;
        line-height: 24px;
        max-height: 446px;
        -ms-overflow-style: none;
      }
    }
  }
}

.start-dialog-btn,
.check-dialog-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  font-size: 16px;
  height: 40px;
  border-radius: 4px;
  width: 455px; //455
  padding: 0 16px;
  width: 100%;
  border: none;

  svg {
    margin-right: 10px;
  }
}

.start-dialog-btn {
  background: $black-170;
}

.check-dialog-btn {
  background: $yellow-90;
}

.upload-list {
  position: relative;
  background-color: $white;
  width: 455px;
  margin: 0 auto;
}
</style>
